import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Marker, Popup } from 'react-map-gl';

import { BookingHeader } from 'components/bookingHeader';
import { Button } from 'components/common/button';
import { DynamicIcon } from 'components/common/dynamicIcon';
import { MapWrapper } from 'components/common/map';

import { useMap } from 'hooks';

import './BookingWidgetMap.css';

const BookingWidgetMap = ({
    height,
    width,
    closeMap,
    markers,
    mapboxAccessToken,
    openPropertyDetails,
}) => {
    const { initialViewState } = useMap({
        height: window.innerHeight - 140,
        width,
        markers,
    });

    const [selectedPopupId, setSelectedPopupId] = useState(null);
    const [filteredMarkers, setFilteredMakers] = useState([...markers]);
    const [filters, setFilters] = useState([]);

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const multipropertyMapText = useSelector(
        (state) =>
            state.multiproperty?.multipropertyOptions?.multipropertyMapText
    );

    if (!height || !width) {
        return null;
    }

    const toggleFilter = (filter) => {
        const updatedFilters = filters.map((_filter) => {
            if (_filter.type === filter.type) {
                _filter.active = !_filter.active;
            }

            return _filter;
        });

        const updatedMarkers = [];

        for (const updatedFilter of updatedFilters) {
            for (const marker of markers) {
                if (
                    updatedFilter.type === marker.type &&
                    updatedFilter.active
                ) {
                    updatedMarkers.push(marker);
                }
            }
        }

        setFilters(updatedFilters);
        setFilteredMakers(updatedMarkers);
    };

    const handleOnClickForProperty = (propertyId) => {
        openPropertyDetails(propertyId);
        closeMap();
    };

    useEffect(() => {
        const uniqueTypes = [];
        const filters = [];

        for (const marker of markers) {
            const type = marker.type;
            const icon = marker.icon;

            if (uniqueTypes.indexOf(type) === -1) {
                uniqueTypes.push(type);
                filters.push({
                    type,
                    icon,
                    active: true,
                });
            }
        }

        setFilters(filters);
    }, []);

    const pins = filteredMarkers.map((marker) => {
        return (
            <div key={`pin-${marker.id}`}>
                <Marker
                    key={`marker-${marker.id}`}
                    longitude={marker.longitude}
                    latitude={marker.latitude}
                    anchor="bottom"
                    onClick={() => {
                        setSelectedPopupId(marker.id);
                    }}
                >
                    {/* <img
                        src="https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png"
                        alt="marker"
                        style={{ cursor: 'pointer' }}
                    /> */}
                    <span className="ab-map-marker-pin">{marker.price}</span>
                </Marker>

                {selectedPopupId === marker.id && (
                    <Popup
                        closeButton={true}
                        closeOnClick={false}
                        closeOnMove={true}
                        key={`popup-${marker.id}`}
                        latitude={marker.latitude}
                        longitude={marker.longitude}
                        onClose={() => setSelectedPopupId(null)}
                        offset={{
                            bottom: { x: 0, y: -50 },
                            top: { x: 0, y: 0 },
                        }}
                    >
                        <div className="ab-map-popup">
                            {/* TODO: WHAT IF THE IMAGE IS MISSING */}
                            <div
                                className="ab-map-popup-header"
                                style={{
                                    backgroundImage: `url("${marker.image}")`,
                                }}
                            ></div>
                            <div className="ab-map-popup-body">
                                <div className="ab-map-popup-title">
                                    {marker.title}
                                </div>
                                <div className="ab-map-popup-subtitle-wrapper">
                                    <div className="ab-map-popup-subtitle">
                                        {/* <DynamicIcon
                                        name={marker.icon}
                                        // color="#fff"
                                        size={14}
                                    />{' '} */}
                                        {marker.price}
                                    </div>
                                    <Button
                                        className="ab-go-to-property-btn"
                                        onClick={() =>
                                            handleOnClickForProperty(
                                                marker.propertyID
                                            )
                                        }
                                        size={12}
                                    >
                                        {Lang?.goToProperty}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
            </div>
        );
    });

    return (
        <div className="ab-room-info-page">
            <BookingHeader onClick={closeMap} title={multipropertyMapText} />
            <MapWrapper
                height={height}
                initialViewState={initialViewState}
                mapboxAccessToken={mapboxAccessToken}
                width={width}
            >
                {pins}
                {filters?.length > 0 && (
                    <div className="ab-marker-filters">
                        {filters.map((filter, index) => {
                            return (
                                <button
                                    key={index}
                                    className={`ab-marker-filter ${
                                        filter.active ? 'active' : ''
                                    }`}
                                    title={filter.type}
                                    onClick={() => toggleFilter(filter)}
                                >
                                    <DynamicIcon name={filter.icon} size={16} />
                                </button>
                            );
                        })}
                    </div>
                )}
            </MapWrapper>
        </div>
    );
};

BookingWidgetMap.propTypes = {
    closeMap: PropTypes.func,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    markers: PropTypes.array,
    mapboxAccessToken: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    openPropertyDetails: PropTypes.func,
};

export default BookingWidgetMap;
